import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from 'src/app/app.constants';
import { RiskActionDetailsViewModel } from '../../risk/models/riskActionDetailsViewModel';
import { RiskActionListViewModel } from '../../risk/models/riskActionListViewModel';
import { Observable } from 'rxjs';
import { FilterViewModel } from '../../shared/models/filter/filterViewModel';
import { map } from 'rxjs/operators';
import { BadgeColor } from '../../shared/components/common/badge/badge.component';
import { RiskActionStatuses } from '../../risk/enums/riskActionStatusType.enum';
import { FilterTypes } from '../../shared/enums/filterTypes';
import { StateService } from '../../planning/services/state.service';

@Injectable({
  providedIn: 'root',
})
export class ActionRiskService extends StateService<RiskActionListViewModel> {

  constructor(private http: HttpClient, private configuration: Configuration) {
    super();
    
  }

  /**
   * Getter that dynamically builds the actionUrl each time.
   * This ensures the URL updates when the backend API changes (e.g., account switching).
   */
  private get actionUrl(): string {
    return this.configuration.buildEndpoint(`RiskActionItem/`);
  }

  create(action: RiskActionDetailsViewModel) {
    return this.http.post(`${this.actionUrl}Add`, action);
  }

  getList(
    filters: FilterViewModel[],
    showPinnedOnly: boolean = false,
    customSortFilter: number = 0
  ): Observable<RiskActionListViewModel[]> {
    return this.http.post<RiskActionListViewModel[]>(`${this.actionUrl}List/${showPinnedOnly}/${customSortFilter}`, filters);
  }

  getDetails(actionId: number): Observable<RiskActionDetailsViewModel> {
    return this.http.get<RiskActionDetailsViewModel>(`${this.actionUrl}Details/${actionId}`);
  }

  update(action: RiskActionDetailsViewModel) {
    return this.http.put(`${this.actionUrl}Update`, action);
  }

  delete(actionId: number) {
    return this.http.delete(`${this.actionUrl}Delete/${actionId}`);
  }

  archive(actionId: number, archive: boolean) {
    return this.http.post(`${this.actionUrl}Archive/${actionId}/${archive}`, null).pipe(
      map((res) => {
        this.deleteFromList(actionId);
        return res;
      })
    );
  }

  addToRisk(riskId: number, actionIds: number[]) {
    return this.http.post(`${this.actionUrl}AddToRisk/${riskId}`, actionIds);
  }

  bulkArchive(actionIds: number[]) {
    return this.http.post(`${this.actionUrl}BulkArchive`, actionIds);
  }

  getStatusColor(action: RiskActionListViewModel): BadgeColor {
    const status: RiskActionStatuses = +action?.filters?.find((f) => f.filterType === FilterTypes.Risk_Action_Status)?.filterValue;
    switch (status) {
      case RiskActionStatuses.NotStarted: {
        return 'gray';
      }
      case RiskActionStatuses.InProgress: {
        return 'green';
      }
      case RiskActionStatuses.Complete: {
        return 'blue';
      }
      case RiskActionStatuses.Slipped: {
        return 'red';
      }
    }
  }
}
